import React from 'react';
import { css } from 'glamor';

const posterImageStyle = {
  backgroundSize: 'cover',
  backgroundPosition: 'center center',
  width: '100%',
  height: '100%'
}

type Props = {
  url: string
};

export default ({ url } : Props) => {

  if (!url) {
    return null;
  }

  return (
    <div { ...css({
      ...posterImageStyle,
        backgroundImage: `url("${url}")`
      })
    }></div>
  )
};



// WEBPACK FOOTER //
// ../src/client/components/videos/PosterImage.js